<template>
  <a-card a-card title="Open VS Click VS Bounce" class="Custom--Card">
    <a-select defaultValue="last-30-days" slot="extra" @change="openClickChangeEvent">
      <a-select-option value="last-30-days">Last 30 Days</a-select-option>
      <a-select-option value="last-month">Last Month</a-select-option>
      <a-select-option value="last-7-days">Last 7 Days</a-select-option>
    </a-select>
    
    <template v-if="loading">
      <div class="loader-container">
        <a-spin :size="'large'" />
      </div>
    </template>
    
    <template v-else>
      <overview-graph
        v-if="chartData.labels.length > 0"
        :labels="chartData.labels"
        :opened="chartData.opened"
        :clicked="chartData.clicked"
        :bounced="chartData.bounced"
      ></overview-graph>
      
      <div v-else class="no-data-container">
        <a-empty description="No data available" />
      </div>
    </template>
  </a-card>
</template>

<script>
import OverviewGraph from "@/components/OverviewGraph.vue";
import { transformSingleOpenClickData } from "@/helpers/chartDataTransformer";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    OverviewGraph
  },
  computed: {
    ...mapGetters({
      openClick: 'sites/graphdata'
    }),
    chartData() {
      return transformSingleOpenClickData(this.openClick);
    }
  },
  methods: {
    openClickChangeEvent: function(evt) {
      let form = '';
      let to = '';
      
      switch (evt) {
        case 'last-30-days':
          form = moment().subtract(30, 'days').format('YYYY-MM-DD');
          to = moment().format('YYYY-MM-DD');
          break;
        case 'last-month':
          form = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          to = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
        case 'last-7-days':
          form = moment().subtract(7, 'days').format('YYYY-MM-DD');
          to = moment().format('YYYY-MM-DD');
          break;
      }
      this.loadGraph(`from=${form}&to=${to}`);
    },
    async loadGraph(evt = 'last-30-days') {
      this.loading = true;
      await this.$store.commit("sites/GET_OPEN_CLICK_DATA", {
        siteId: this.$route.params.siteId,
        query: evt
      });
      this.loading = false;
    }
  },
  created() {
    this.openClickChangeEvent('last-30-days');
  }
};
</script>

<style scoped>
.no-data-container {
  text-align: center;
  padding: 40px 0;
}
</style>